import { useEffect, useRef, useState } from 'react';

import { API_URL } from '../../../constants/endpoints';
import sessionFetch from '../../../middleware/sessionFetch';


// Картинку рисует сервер (тем же кодом, что и при отправке), поэтому превью
// совпадает с тем, что получит клиент. Запрос уходит с задержкой, чтобы не
// слать его на каждую букву. body = null: картинки нет.
function useRenderedImage(body, delay = 450) {
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');
  const current = useRef('');
  const key = body ? JSON.stringify(body) : '';

  useEffect(() => {
    if (!key) {
      setUrl('');
      setError('');
      return undefined;
    }

    let cancelled = false;
    const timer = setTimeout(async () => {
      try {
        const response = await sessionFetch(`${API_URL}/api/whatsapp/images/preview`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: key,
        });
        if (!response.ok) {
          const json = await response.json().catch(() => ({}));
          throw new Error((json.data && json.data.type) || 'Не удалось построить картинку');
        }
        const blob = await response.blob();
        if (cancelled) return;
        const next = URL.createObjectURL(blob);
        if (current.current) URL.revokeObjectURL(current.current);
        current.current = next;
        setUrl(next);
        setError('');
      } catch (err) {
        if (!cancelled) setError(err.message);
      }
    }, delay);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [key, delay]);

  useEffect(
    () => () => {
      if (current.current) URL.revokeObjectURL(current.current);
    },
    []
  );

  return { url, error };
}

export default useRenderedImage;
